import {
  createBreederCategoryGetServerSideProps,
  createBreederCategoryPage,
} from '@web/library/breeder-category-page';
import { Animal } from 'shared/@generated/models';

const config = {
  animal: Animal.Dog,
  translationKey: 'dogs',
};

export default createBreederCategoryPage(config);

export const getServerSideProps = createBreederCategoryGetServerSideProps(config);
